import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/font-awesome';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';



export default /*#__PURE__*/_defineComponent({
  __name: 'SeeOffers',
  emits: ["seeMoreOffers"],
  setup(__props, { expose: __expose }) {
  __expose();




const __returned__ = { get Icons() { return Icons }, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})